import Head from 'next/head'
import Link from 'next/link'
import styles from './Button.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'
import { isOwnSiteUrl } from 'lib/url'

interface Props {
  text: string
  href: string
  isExternal?: boolean
  skinColor?: boolean
  dynamicIcon?: string
  red?: string
  middleRed?: string
}

const Button: React.FC<Props> = ({ text, href, isExternal, skinColor, dynamicIcon, red, middleRed }) => {
  const isNoreferrer = (href: string) => {
    // 自社サイトのURLの場合noreferrerを外す
    if (isOwnSiteUrl(href)) {
      return ''
    }
    // https,httpから始まっているURLでない場合（/文字列/）noreferrerを外す
    if (!/https?:\/\/[^\s/$.?#].[^\s]*/.test(href)) {
      return ''
    }
    return 'noreferrer'
  }

  const buttonClasses = [
    styles.button,
    skinColor ? styles.skin : '',
    red ? styles.red : '',
    middleRed ? styles.middleRed : '',
    isExternal ? styles.isExternal : '',
    styles.button_primary,
  ].join(' ')

  return (
    <>
      <Head>
        <link rel="preload" href="/img/common/direction_white.svg" as="image" />
        <link rel="preload" href="/img/common/direction_grayblack.svg" as="image" />
        <link rel="preload" href="/img/common/direction_red.svg" as="image" />
        <link rel="preload" href="/img/common/link_box.svg" as="image" />
        <link rel="preload" href="/img/common/link_box_white.svg" as="image" />
        {dynamicIcon && <link rel="preload" href={dynamicIcon} as="image" />}
      </Head>
      {isExternal ? (
        <a href={href} target="_blank" rel={`noopener ${isNoreferrer(href)}`} className={buttonClasses}>
          <div className={styles.buttonInner}>
            <span>{text}</span>
            <img
              src={dynamicIcon || '/link_box_white.svg'}
              className={styles.isExternalIcon}
              alt={text}
              width={20}
              height={20}
            />
          </div>
        </a>
      ) : (
        <Link href={href}>
          <a href={href} className={buttonClasses}>
            <div className={styles.buttonInner}>
              <span>{text}</span>
              <img
                src={dynamicIcon || '/direction_white.svg'}
                className={styles.icon}
                alt={text}
                width={20}
                height={20}
              />
            </div>
          </a>
        </Link>
      )}
    </>
  )
}

export default Button
